module.exports = import("https://fpjscdn.net/v3/o3Y8wAVEOe9ZrpPFdlte");;